import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import api from '../../api/endpoints';
import { handleErrors, fetch } from '../../api';

function* editAccountName({ payload: { values, onSuccess, handledErrors } }) {
  
  try {
    const { data } = yield call(fetch, { api: api.profile.name_edit, data: values });

    onSuccess();
    yield put(actions.editAccountNameDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.editAccountNameFailed,
      handledErrors,
      endpoint: api.profile.name_edit.url
    });
  }
}

export const editAccountNameSaga = takeEvery(types.EDIT_ACCOUNT_NAME_REQUEST, editAccountName);